var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5917 6.00833C15.4353 5.85057 15.2223 5.76183 15.0001 5.76183C14.7779 5.76183 14.5649 5.85057 14.4084 6.00833L8.20006 12.225L5.59173 9.60833C5.3729 9.39695 5.05793 9.31837 4.76545 9.40218C4.47298 9.486 4.24744 9.71948 4.17379 10.0147C4.10014 10.3099 4.18957 10.6219 4.40839 10.8333L7.60839 14.0333C7.76486 14.1911 7.97786 14.2798 8.20006 14.2798C8.42226 14.2798 8.63525 14.1911 8.79173 14.0333L15.5917 7.23333C15.7627 7.07557 15.86 6.8535 15.86 6.62083C15.86 6.38817 15.7627 6.16609 15.5917 6.00833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3e539f3c25bb1cf9575bebd1e5d71824.svg";
export { ForwardRef as ReactComponent };